import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcHelp = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M10.49 9.587c.138-.988.98-1.337 1.51-1.337.967 0 1.533.653 1.502 1.248-.024.45-.278.726-.913 1.234l-.112.088c-.533.418-1.477 1.158-1.477 2.426a1 1 0 1 0 2 0c0-.222.11-.371.837-.952l.02-.015c.592-.473 1.567-1.252 1.642-2.677C15.607 7.532 13.75 6.25 12 6.25c-1.116 0-3.166.725-3.49 3.063a1 1 0 0 0 1.98.274ZM12 17.5a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcHelp");

export { IcHelp };
//# sourceMappingURL=ic-help.js.map
